/**
 * Created by Administrator on 2019/11/4.
 */
// Created by hejikun on 2017/11/2 0002.
let patientReport = [
  {
    path: '/news',
    name: '消息列表',
    component: () => import('@/pages/patientReport/news')
  },
  {
    path: '/report_talk',
    name: '消息',
    component: () => import('@/pages/patientReport/report_talk')
  },
  {
    path: '/report_order_info',
    name: '随访详情',
    component: () => import('@/pages/patientReport/report_order_info')
  },
  {
    path: '/report_order_confirm',
    name: '随访',
    component: () => import('@/pages/patientReport/report_order_confirm')
  },
  {
    path: '/report_my_doc',
    name: '报到医生',
    component: () => import('@/pages/patientReport/report_my_doc')
  }
]

export default patientReport
